import React from 'react';

const SmoothScroll = ({ children }) => {
    return <>{children}</>;
};

export default SmoothScroll;
